import { Module, VuexModule, Mutation } from "vuex-module-decorators";
import subDays from "date-fns/subDays";
import endOfDay from "date-fns/endOfDay";

@Module({
  namespaced: true,
  name: "StationOCPPLogs"
})
export default class StationOCPPLogs extends VuexModule {
  start = subDays(new Date(), 7);
  end = endOfDay(new Date());

  @Mutation
  setStart(date: Date) {
    this.start = date;
  }

  @Mutation
  setEnd(date: Date) {
    this.end = date;
  }
}
